import createContainer from 'constate';
import { useEffect, useState } from 'react';
import { addToListCommerce, deleteFromListCommerce, getAllListsCommerce } from './cart/myLists';
import { nameHOC } from './hocutils';
import { useUserContex } from './UserContext';

function useMyListsContextHook({ data: initialData, appCtx }) {
  const isMyListsEnabled = appCtx?.siteConfig?.toggles?.isMyListsEnabled ?? false;
  const userContext = useUserContex();
  const [myListData, setMyListData] = useState(initialData || []);
  const [error, setError] = useState('');
  const [showMyLists, setShowMyLists] = useState(false);
  const [addedLists, setAddedLists] = useState([]);
  const [undo, setUndo] = useState();
  const [alertType, setAlertType] = useState('success');

  const getAllLists = async ({ listType }) => {
    const response = await getAllListsCommerce({
      appCtx,
      listType,
    });
    if (response.ok) {
      setShowMyLists(true);
      setMyListData(response.data.lists || []);
    } else {
      setError(response.error_code || 'error');
    }
    return response;
  };

  useEffect(() => {
    if (isMyListsEnabled && userContext.isUserLoggedIn) getAllLists({});
  }, [userContext.isUserLoggedIn]);

  const addTolList = async ({ listType, tagName, product }) => {
    return addToListCommerce({
      tagName,
      listType,
      product,
      appCtx,
    });
  };

  const deleteFromList = async (listId, listLineItemId, tagName) => {
    return deleteFromListCommerce({ appCtx, listId, listLineItemId, tagName });
  };
  return {
    myLists: {
      myListData,
      addTolList,
      setMyListData,
      getAllLists,
      deleteFromList,
      error,
      setAddedLists,
      addedLists,
      setUndo,
      undo,
      alertType,
      setAlertType,
      showMyLists,
    },
  };
}

const [MyListsContextProvider, useMyListsContext] = createContainer(useMyListsContextHook);

const withMyLists = (WrappedComponent) => {
  const { getInitialProps } = WrappedComponent;
  const ComponentWithMyLists = (props) => {
    const { myLists } = useMyListsContext();
    return <WrappedComponent {...props} myLists={myLists} />;
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithMyLists.getInitialProps = getInitialProps;
  }
  ComponentWithMyLists.originalName = nameHOC(WrappedComponent);
  ComponentWithMyLists.displayName = nameHOC(WrappedComponent, 'WithMyListsContext');

  return ComponentWithMyLists;
};
export { withMyLists, MyListsContextProvider, useMyListsContext };
